
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M384 223.1h-32v-96C352 56.52 294.59 0 224 0S96 57.42 96 127.1v95.1l-32 .9c-35.35 0-64 28.65-64 64v160c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64v-160c0-34.4-28.7-64-64-64zm-272-96c0-61.75 50.25-112 112-112s112 50.25 112 112v96H112v-96zm320 320c0 26.47-21.53 48-48 48H64c-26.47 0-48-21.53-48-48v-160c0-26.47 21.53-47.1 48-47.1h320c26.47 0 48 21.53 48 47.1v160z"}})])
          )
        }
      }
    